<form [formGroup]="formName">
    <div fxLayout="row" fxLayoutAlign="space-around center">
        <mat-form-field appearance="outline" [ngStyle]="{'width': fileExists ? dynamicWidth : '100%'}">
            <mat-label>{{field.label}}</mat-label>
            <ngx-mat-file-input [formControlName]="field.fieldName" [multiple]="field.multiple" [accept]="field.accept"
                [color]="field.color">
            </ngx-mat-file-input>
        </mat-form-field>
        <img *ngIf="fileExists" src="{{imageUrl}}" alt="" class="img-user">
    </div>
</form>